import React, { Suspense } from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import FullPageSpinner from '@components/FullPageSpinner';
import AxiosInterceptor from '@components/AxiosInterceptor';
import ProtectedRoute from '@components/ProtectedRoute';
import { authenticatedRoutes } from '@/routes/authenticatedRoutes/authenticatedRoutesConfig';

const AuthenticatedApp = () => {
  return (
    <BrowserRouter>
      <AxiosInterceptor />
      <Routes>
        {authenticatedRoutes.map(
          ({ path, component: Component, lazyComponent, props, allowedRoles }, index) => {
            if (Component) {
              return (
                <Route
                  key={index}
                  path={path}
                  element={
                    <ProtectedRoute allowedRoles={allowedRoles}>
                      <Component {...(props || {})} />
                    </ProtectedRoute>
                  }
                />
              );
            } else if (lazyComponent) {
              const LazyComp = React.lazy(lazyComponent);
              return (
                <Route
                  key={index}
                  path={path}
                  element={
                    <ProtectedRoute allowedRoles={allowedRoles}>
                      <Suspense fallback={<FullPageSpinner />}>
                        <LazyComp />
                      </Suspense>
                    </ProtectedRoute>
                  }
                />
              );
            }
            return null;
          }
        )}
        <Route path="/*" element={<Navigate to="/" />} />
      </Routes>
    </BrowserRouter>
  );
};

export default AuthenticatedApp;
